import PropTypes from 'prop-types'

import { FieldLabel, FieldRow, FieldValue, FieldValueSpacer } from './ProfileStyle'

/** A single label/value row inside a profile card. */
const ProfileField = ({ label, value, className }) => (
  <FieldRow className={className}>
    <FieldLabel>{label}</FieldLabel>
    <FieldValue>{value}</FieldValue>
  </FieldRow>
)

ProfileField.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  className: PropTypes.string,
}

/**
 * Labels the fields beneath it. It sits in the label column like a field does,
 * so it keeps the value column reserved, but has no value of its own and so must
 * not hold the blank line that a field with nothing on record keeps.
 */
export const ProfileFieldHeading = ({ children }) => (
  <FieldRow>
    <FieldLabel>{children}</FieldLabel>
    <FieldValueSpacer />
  </FieldRow>
)

ProfileFieldHeading.propTypes = {
  children: PropTypes.node,
}

export default ProfileField
